"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getItemByKey = function (key, list, value) {
    for (var _i = 0, _a = list || []; _i < _a.length; _i++) {
        var item = _a[_i];
        if (item[key] === value) {
            return item;
        }
    }
    return undefined;
};
exports.getItemByKey = getItemByKey;
//# sourceMappingURL=getItemByKey.js.map